<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="title" width="500px" @close="init">
    <div slot="content">
      <el-form :model="eventData" :rules="formRules" ref="eventForm" label-position="top">
        <el-form-item label="Sub OID" prop="snmpOid">
          <el-input v-model="eventData.snmpOid"></el-input>
        </el-form-item>
        <el-row type="flex" justify="space-between" :gutter="20">
          <el-col :span="12">
            <el-form-item label="판단 순위" prop="eventIndex">
              <el-input-number v-if="title !== '정책 수정'" v-model="eventData.eventIndex" controls-position="right" :min="1" />
              <span v-else>{{eventData.eventIndex}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="정책 등급">
              <el-select v-model="eventData.eventlevelId">
                <el-option v-for="event in eventlevelInfo" :key="event.eventlevelId" :label="event.eventlevelName" :value="event.eventlevelId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between" :gutter="20">
          <el-col :span="12">
            <el-form-item label="판단 조건">
              <el-switch v-model="eventData.judgeFlag" active-value="Y" inactive-value="N" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="적용 여부">
              <el-switch v-model="eventData.applyFlag" active-value="Y" inactive-value="N" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col class="mr-r4" :span="6">
            <el-form-item label="조건">
              <el-select v-model="eventData.judgeCondition" :disabled="eventData.judgeFlag === 'N'">
                <el-option v-for="condition in judgeConditions" :key="condition.value" :label="condition.label" :value="condition.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="값">
              <el-input v-model="eventData.judgeValue" :disabled="eventData.judgeFlag === 'N'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickClose">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters } from 'vuex';

import msgUtils from '@/utils/message';
import snmptrapSettingAPI from '@/api/settings/log/snmptrap-settings';

export default {
  name: 'WTrapEventSettingPopup',
  props: {
    title: {
      type: String,
    },
    oidData: {
      type: Object,
    },
    selectedEventData: {
      type: Object,
    },
    maxEventIndex: {
      type: Number,
    },
    eventDatas: {
      type: Array,
    },
  },
  data() {
    const judgeConditions = [
      {
        label: '==',
        value: 'EQ',
      },
      {
        label: '!=',
        value: 'NEQ',
      },
      {
        label: '<',
        value: 'LT',
      },
      {
        label: '>',
        value: 'GT',
      },
      {
        label: '<=',
        value: 'LE',
      },
      {
        label: '>=',
        value: 'GE',
      },
      {
        label: '포함',
        value: 'CT',
      },
      {
        label: '미포함',
        value: 'NCT',
      },
    ];
    /**
     * eventIndex의 유효성 검사 룰. 판단 순위가 중복되지 않는지 확인한다.
     * @author Minyeong
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    const eventIndexRule = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('필수 정보입니다.'));
      }
      const index = findIndex(this.eventDatas, { eventIndex: value });
      if (index !== -1) {
        if (isEmpty(this.eventOriginData)) {
          return callback(new Error('중복된 판단 순위입니다.'));
        } else if (this.eventData.eventIndex !== this.eventOriginData.eventIndex) {
          return callback(new Error('중복된 판단 순위입니다.'));
        }
      }
      return callback();
    };
    const snmpOidRule = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('필수 정보입니다.'));
      }
      if (!/^([1-9][0-9]{0,3}|0)(\.([1-9][0-9]{0,3}|0)){5,13}$/.test(value)) {
        return callback(new Error('잘못된 형식입니다.'));
      }
      return callback();
    };
    const formRules = {
      // TODO snmpOid Validation
      snmpOid: [
        { required: true, validator: snmpOidRule, trigger: 'blur' },
      ],
      eventIndex: [
        { required: true, validator: eventIndexRule, trigger: 'change' },
      ],
    };
    return {
      formRules,
      judgeConditions,
      eventData: {
        snmpOid: '',
        eventIndex: 1,
        eventlevelId: null,
        judgeFlag: 'N',
        judgeCondition: '',
        judgeValue: '',
        applyFlag: 'Y',
      },
      eventOriginData: {},
    };
  },
  computed: mapGetters(['eventlevelInfo']),
  watch: {
    selectedEventData: {
      immediate: true,
      handler() {
        if (this.title === '정책 수정' && !isEmpty(this.selectedEventData)) {
          this.eventData = cloneDeep(this.selectedEventData);
          this.eventOriginData = cloneDeep(this.selectedEventData);
        }
      },
    },
  },
  methods: {
    /**
     * 트랩 정책 설정 팝업창 데이터를 초기화한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    init() {
      this.eventData = {
        snmpOid: '',
        eventIndex: this.maxEventIndex + 1,
        eventlevelId: '',
        judgeFlag: 'N',
        judgeCondition: '',
        judgeValue: '',
        applyFlag: 'Y',
      };
      // validation 초기화
      const clear = ['snmpOid', 'eventIndex'];
      this.$refs.eventForm.clearValidate(clear);
      this.$emit('init-form-data');
    },
    open() {
      if (isEmpty(this.selectedEventData)) {
        this.eventData.eventIndex = this.maxEventIndex + 1;
      }
      this.$refs.slidingPopup.open();
    },
    clickClose() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 저장 버튼 클릭 정책 : 폼의 유효성 검사 후 데이터를 저장(업데이트)한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveButton() {
      if (isEmpty(this.eventData.eventlevelId)) {
        this.$message(msgUtils.getCustomMsgData('정책 등급을 선택해주세요.'));
        return;
      }
      this.$refs.eventForm.validate().then((success) => {
        if (success) {
          let snmpOid = this.eventData.snmpOid;
          if (snmpOid.indexOf('.') === 0) {
            snmpOid = snmpOid.substring(1, snmpOid.length);
            this.eventData.snmpOid = snmpOid;
          }
          this.eventData.snmptrapVersion = this.oidData.snmptrapVersion;
          this.eventData.snmptrapOid = this.oidData.snmptrapOid;
          if (this.title === '정책 추가') {
            snmptrapSettingAPI.insertSnmptrapEventRule(this.eventData).then((response) => {
              if (response.data.success) {
                if (response.data.data === 'Duplicate') {
                  this.$message(msgUtils.getCustomMsgData('중복된 정책입니다.'));
                  return;
                } else if (response.data.data === 'Error') {
                  this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '정책', false));
                  return;
                }
                this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '정책', response.data.success));
                this.clickClose();
                this.$emit('update-event-inform');
              } else {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '정책', response.data.success));
              }
            }).catch((e) => {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '정책', false));
              throw new Error(e);
            });
          } else {
            snmptrapSettingAPI.updateSnmptrapEventRule(this.eventData).then((response) => {
              if (response.data.success) {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '정책', response.data.success));
                this.clickClose();
                this.$emit('update-event-inform');
              } else {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '정책', response.data.success));
              }
            }).catch((e) => {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '정책', false));
              throw new Error(e);
            });
          }
        }
      }).catch(() => {});
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log/SnmpTrap/popup/TrapEventSettingPopup.vue